var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg1 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 101",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Mesa de trabajo 12")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M50,.5a50,50,0,1,0,50,50A50.06,50.06,0,0,0,50,.5Zm0,92.68A42.68,42.68,0,1,1,92.68,50.49,42.73,42.73,0,0,1,50,93.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M81.25,55.91a3.7,3.7,0,0,0-1-.13v0L19.83,56h0a3.82,3.82,0,0,0-1,.14,3.66,3.66,0,0,0-2.44,4.56A35,35,0,0,0,50,85.66a35.35,35.35,0,0,0,33.72-25.2A3.66,3.66,0,0,0,81.25,55.91ZM50,78.33A28.07,28.07,0,0,1,25.28,63.27l49.53-.18A28,28,0,0,1,50,78.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 38.69,
    cy: 45.67,
    r: 4.83
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 61.31,
    cy: 45.67,
    r: 4.83
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/1.9f5ab386.svg";
export { ForwardRef as ReactComponent };